 <template>
 <div>
   <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-row>
            <v-col>
        <v-icon x-large color="yellow">report_problem</v-icon><span style="font-size:18px; font-weight:bold"> Desejas continuar essa operação?</span>
        </v-col>
        </v-row>
          </v-card-title>
        <v-card-text><span style="color:red"> Esta operação resultará na cobrança deste serviço</span>, se desejares previsualizar a declaração então escolha a outra tag, caso contrario clique em concordar</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="printDeclaracao(true)">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialog=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-sheet class="pa-5">
          <v-toolbar-title>Emitir Declaração  </v-toolbar-title>
          <div>
             <v-alert v-if="sucess" type="success">
      Estudante encontrado .
    </v-alert>
             <v-alert v-if="err" type="error">
     Estudante não encontrado.
    </v-alert>
            </div>
          <v-row>
               <v-col  cols="12" sm="1" md="2">
               <v-text-field
                        v-model="matricula"
                        label="Matricula do aluno"
                      ></v-text-field>
  </v-col>
  <div style=" padding-top:40px;">
                <v-btn class="mx-2" fab dark small color="primary" @click="dadosDoAluno (matricula)">
      <v-icon dark>search</v-icon>
    </v-btn>
    </div>
 <v-col  cols="12" md="4">
    <v-select
              v-model="editedItem.idEfeito"
              item-value="idEfeito"
              item-text="descricao"
              @change="filterEfeito(editedItem.idEfeito)"
              :items="efeitos"
              :disabled="disabled"
              label="Efeitos"
            ></v-select>
          </v-col>
          </v-row>
       <span v-if="aluno.length > 0"> Estudante: {{nomeAluno}} </span>
          <v-row>
              <div>
                <v-btn v-if="aluno.length > 0 && editedItem.idEfeito"  class="mx-2" fab dark small color="primary" @click="printDeclaracao(false)">
      <v-icon dark>visibility</v-icon>
    </v-btn>

    <v-btn v-if="aluno.length > 0 && editedItem.idEfeito && this.canPrint.length > 0 "  class="mx-2" fab dark small color="pink" @click="openDialog()">
      <v-icon dark>print</v-icon>
    </v-btn>
              </div>
               <v-col  cols="12" md="4">
                 <v-progress-circular v-if="isLoading" class="v-progress-circular" style="color:blue"
      :size="50"
      :width="10"
      indeterminate
      color="blue"
    ></v-progress-circular>
                 </v-col>
  </v-row>
  </v-sheet>

 </div>

</template>

<script>
import axios from '../../plugins/axios'
import jsreport from 'jsreport-browser-client-dist/jsreport'
const ls = require('local-storage')
export default {
  data: () => ({
    err: false,
    sucess: false,
    matricula: '',
    status_2: false,
    dialog: false,
    disabled: true,
    dados: null,
    isLoading: false,
    nomeSubDirectoraPedagogica: '',
    formacaoSubDirectoraPedagogica: '',
    canPrint: [],
    aluno: [],
    nomeAluno: '',
    efeitos: [],
    editedItem: {
      idEfeeito: 0,
      descricao: ''
    }

  }),
  created () {
    this.efeitosDeclaracao()
    // check if classe has been selected otherwise send back to painel to select
  },

  computed: {

  },

  methods: {

    async efeitosDeclaracao () {
      this.isLoading = true

      try {
        this.efeitos = await axios
          .get('/efeitos-declaracao')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async dadosDoAluno (matricula) {
      this.isLoading = true
      const matriculaInstituicao = {
        matricula: matricula,
        idinstituicao: ls.get('i_id')
      }
      try {
        this.aluno = await axios
          .post('/dados-pessoaisDoAlunoDestaInstituicao', matriculaInstituicao)
          .then(res => res.data)
        this.isLoading = false
        this.existeAluno()
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    existeAluno () {
      if (this.aluno.length > 0) {
        this.nomeAluno = this.aluno[0].nome
        this.putRascunho()
        this.sucess = true
        this.disabled = false
        setTimeout(() => {
          this.sucess = false
        }, 2000)
      } else {
        this.err = true
        setTimeout(() => {
          this.err = false
        }, 2000)
      }
    },
    filterEfeito (idEfeito) {
      if (idEfeito) { this.editedItem.descricao = this.efeitos.filter(t => t.idEfeito === idEfeito)[0].descricao }
    },
    convertDate (dateString) {
      var p = dateString.split('-')
      return [p[2], p[1], p[0] ].join('/')
    },
    async printDeclaracao (bottonPrint) {
      let rascunhoVisivel = true
      if (this.canPrint.length && bottonPrint) { rascunhoVisivel = false }
      try {
        this.isLoading = true
         jsreport.serverUrl = 'http://192.168.1.9:5000'//'http://restrito.esaudeluanda.com:5000' // http://localhost:5000/api/report
        // jsreport.serverUrl = 'http://:5000'
        jsreport.headers['Authorization'] = 'Basic ' + btoa('report:lobato2121')
        var request = {
          template: { 'shortid': 'Syb-J2a_I' },
          data: {
            'nome_aluno': this.aluno[0].nome.toUpperCase(),
            'pai': this.aluno[0].nomedopai.toUpperCase(),
            'mae': this.aluno[0].nomedamae.toUpperCase(),
            'naturalidade': this.aluno[0].municipio,
            'provincia': this.aluno[0].provincia,
            'bi': this.aluno[0].bi,
            'curso': this.aluno[0].curso,
            'anoLectivo': this.aluno[0].anoLectivo,
            'data_nascimento': this.convertDate((this.aluno[0].datanascimento).substring(0, 10)),
            'data_emissao': this.convertDate((this.aluno[0].dataemissaobi).substring(0, 10)),
            'efeitos': this.editedItem.descricao,
            'rascunhoimge': 'https://softlineangola.com/wp-content/uploads/2020/04/rascunho-1.png',
            'rascunho_visivel': rascunhoVisivel,
            'instituicaodescricao': this.aluno[0].instituicaodescricao.toUpperCase(),
            'idinstituicao': this.aluno[0].instituicao,
            'sigla': ls.get('sigla')
          }

        }

        // display report in the new tab

        jsreport.renderAsync(request).then(function (res) {
          var url = res.toDataURI()
          var url_with_name = url.replace('data:application/pdf;', 'data:application/pdf;name=myname.pdf;')
          var html = '<html>' +
	'<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
	'<body>' +
	'<iframe target="_self" type="application/pdf" src="' + url_with_name + '"></iframe>' +
  '</body></html>'

          var a = window.open('about:blank', 'Zupfnoter')
          a.document.write(html)

          a.document.close()
        })
        this.isLoading = false
        this.descontarEmulumentoPago()
      } catch (error) {

      }
      this.dialog = false
    },
    openDialog () {
      this.dialog = true
    },
    async  putRascunho () {
      try {
        this.canPrint = await axios
          .get('/verificarPagamento/' + this.aluno[0].instituicao)
          .then(res => res.data)
      } catch (error) {
        console.log('A API verificarPagamento) ' + error)
        this.text = error
      }
    },
    async descontarEmulumentoPago () {
      if (this.canPrint.length) {
        if (this.canPrint[0].quantidade_inicial > this.canPrint[0].consumo) {
          let descontandoEmolumento
          const value = {
            pkpagamentoEmolumento: this.canPrint[0].pkpagamentoEmolumento,
            consumo: ((this.canPrint[0].consumo) + 1),
            idPessoa: ls.get('nomeUsuario')
          }
          try {
            descontandoEmolumento = await axios
              .post('/DescontarEmolumentoPago', value)
              .then(res => res.data)
          } catch (error) {
            this.text = error
          }
        }
      }
    }
  }

}

</script>
